/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import PropTypes from 'prop-types';
import DateRangePicker from '../DateRangePicker/DateRangePicker';
import DateRangeCBI from '../components/ClearBI/DateRangeCBI';

const CalloutBasic = ({ dateRange, handleDateRangePicker }) => {
  const [isCalloutVisible, setIsCalloutVisible] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const openCalendarVisibility = (event) => {
    setAnchorEl(event.currentTarget);
    setIsCalloutVisible(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsCalloutVisible(false);
  };

  return (
    <>
      <DateRangeCBI
        startDate={dateRange ? dateRange[0] : undefined}
        endDate={dateRange ? dateRange[1] : undefined}
        onClick={openCalendarVisibility}
      />
      {isCalloutVisible && (
        <Popover
          open={isCalloutVisible}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <DateRangePicker
            dates={dateRange}
            handleDateRangePicker={handleDateRangePicker}
            onClose={handleClose}
          />
        </Popover>
      )}
    </>
  );
};

CalloutBasic.propTypes = {
  dateRange: PropTypes.array,
  handleDateRangePicker: PropTypes.func.isRequired,
};

CalloutBasic.defaultProps = {
  dateRange: []
};

export default CalloutBasic;
